export default {
	data: [
		{
			id: '2096',
			name: '부산광역시',
		},
		{
			id: '2094',
			name: '충청북도',
		},
		{
			id: '2103',
			name: '충청남도',
		},
		{
			id: '2092',
			name: '제주도',
		},
		{
			id: '2093',
			name: '전라북도',
		},
		{
			id: '2102',
			name: '전라남도',
		},
		{
			id: '2098',
			name: '인천광역시',
		},
		{
			id: '2095',
			name: '강원도',
		},
		{
			id: '2104',
			name: '광주광역시',
		},
		{
			id: '2099',
			name: '경기도',
		},
		{
			id: '2100',
			name: '경상북도',
		},
		{
			id: '2106',
			name: '경상남도',
		},
		{
			id: '2097',
			name: '서울특별시',
		},
		{
			id: '2101',
			name: '대구광역시',
		},
		{
			id: '2105',
			name: '대전광역시',
		},
		{
			id: '2107',
			name: '울산광역시',
		},
		{
			id: '4245',
			name: '세종특별자치시',
		},
	],
}
